<script>
    import { slide } from 'svelte/transition';
    import { Link } from 'svelte-routing';
	import { quintOut } from 'svelte/easing';
    import {
        getUiFriendlyName
    } from '../helpers.svelte';
    import FilterTag from '../components/FilterTag.svelte';
    import BetaOptInButtonModal from '../components/BetaOptInButtonModal.svelte';
    import Item from '../components/Item/index.svelte';
    export let feedName;
    let itemCount;
	let items = [];
    let filteredItems = [];
    let showFilter = false;
    let allFilters = [];

    let selectedFilters = new Set();
    let hiddenDomains = new Set();

    $: selectedFiltersLength = selectedFilters.size;
    $: hiddenDomainsLength = hiddenDomains.size;

    $: computedFilters = filteredItems.reduce((agg, item) => {
        item.categories.forEach(filter => agg.add(filter));
        return agg;
    }, new Set());

    $: {
        if (selectedFiltersLength) {
            const selectedFiltersArray = Array.from(selectedFilters);
            filteredItems = filteredItems.filter(item => selectedFiltersArray.every(term => item.categories.indexOf(term) > -1))
            itemCount = filteredItems.length;
        } else if (hiddenDomainsLength) {
            // filteredItems = items;
            // itemCount = filteredItems.length;
            filteredItems = filteredItems.filter(item => !hiddenDomains.has(item.link.split('/')[2]) )
            itemCount = filteredItems.length;
        } else {
            filteredItems = items;
            itemCount = filteredItems.length;
        }
    }

	function getFeed() {
		fetch(`/json/${feedName}`)
			.then(data => data.json())
			.then(res => {
				itemCount = res.items.length;
				items = res.items;
                filteredItems = res.items;

                setInitialFilters();
			})
	}

    async function setInitialFilters() {
        // this could come from the backend as well.
        const initialFilters = new Set();
        filteredItems.forEach(item => item.categories.forEach(category => initialFilters.add(category)));
        allFilters = Array.from(initialFilters);
    }

	const trucatedDescription = description => {
		const truncatedDescription = description.length < 300 ? description : description.slice(0, 300) + '...';
		return truncatedDescription
	}

    const getDate = date => {
        const timePart = '00:00:00 GMT';

        if (date.endsWith(timePart)) {
            date = date.slice(0, -timePart.length);
        }

        return date;
    };

    const filterAwaySource = (domain) => {
        // filter away all urls from items that are from 'domain'.
        // set filteredItems
        // filteredItems = filteredItems.filter(item => item.link.split('/')[2] !== domain);
        // itemCount = filteredItems.length;

        hiddenDomains.add(domain);
        hiddenDomains = hiddenDomains;
    }

    const clearFilters = () => {
        hiddenDomains = new Set();
        selectedFilters = new Set();
    }

    const showFilters = () => {
        showFilter = true;
    }
    const hideFilters = () => {
        showFilter = false;
    }

    const addItemToFilters = filter => {
        if (selectedFilters.has(filter)) {
            selectedFilters.delete(filter);
        } else {
            selectedFilters.add(filter);
        }

        selectedFilters = selectedFilters;
    }

    getFeed();
</script>

<Link to="/">Home</Link>


<BetaOptInButtonModal />
<main>

    <div style="position:fixed;display:flex;    
        min-width: 300px;
        max-width: 600px;
        width: 95%;
        justify-content: flex-end;">
        <button on:click="{showFilters}">filters</button>
        <button on:click="{clearFilters}">clear</button>
    </div>
    
    <h2 style="max-width:300px;">{getUiFriendlyName(feedName)}</h2>

	<div>
		{#each filteredItems as item, index (index)}
            <Item index={index} item={item} filterAwaySource={filterAwaySource} />
		{/each}
	</div>

    {#if showFilter}
        <div 
            style="position: fixed;top: 0;left: 0;right: 0;bottom:0;background: whitesmoke;overflow:scroll;" 
            transition:slide="{{delay: 250, duration: 300, easing: quintOut }}">

            <h4>Filters</h4>
            <p>count: {itemCount}</p>
            <div class="filterBox">
                {#each allFilters as filter}
                    <FilterTag 
                        filter={filter}
                        selectedFilters={selectedFilters}
                        computedFilters={computedFilters}
                        on:click="{() => addItemToFilters(filter)}" 
                    />
                {/each}
            </div>
            <div style="position:fixed;top:0;right:0">
                <button on:click="{hideFilters}">✖️</button>
            </div>
        </div>
    {/if}
</main>

<style>
    main {
        max-width: 600px;
        margin: auto;
    }

    h2 {
        margin-top: 35px;
    }

    @media only screen and (max-width: 767px) {

    }
</style>